export default "__VITE_ASSET__Dz2_Hjur__"